/* script */

import Vue from 'vue/dist/vue.esm.js';
import { store }  from '../store';
import { mapGetters } from 'vuex'
import bus        from '../bus.js';
import WaveSurfer from 'wavesurfer.js';
import PlayImage  from '@/components/elements/PlayImage.vue';
import PauseImage from '@/components/elements/PauseImage.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faVolumeUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

library.add(faVolumeUp);
Vue.component('font-awesome-icon', FontAwesomeIcon)

const __vue_script__ = {
	components: {
		PlayImage,
		PauseImage,
	},
	data () {
		return {
			playlistIndex: 0,
			artworkImage: '',
			producerName: '',
			trackName: '',
			trackLink: '',
			cartTotal: '',
			audioSources: [],
			beatsOnDeck: [],
			isPlaying: false,
			hasPlayedOnce: false,
			isRepeating: false,
			volume: 100,
			playerVolWidth: 100,
			volumeDrawerVisible: false,
			playlistSource: ui_data.themeUrl + '/assets/images/svg/playlist-icon.svg',
			shoppingCartSource: ui_data.themeUrl + '/assets/images/svg/019-shopping-cart.svg',
			repeatSvg: ui_data.themeUrl + '/assets/images/svg/repeat.svg',
			shuffleSvg: ui_data.themeUrl + '/assets/images/svg/shuffle.svg',
			playButtonSource: ui_data.themeUrl + '/assets/images/svg/play-gradient.svg',
			pauseButtonSource: ui_data.themeUrl + '/assets/images/svg/pause.svg',
			nextButtonSource: ui_data.themeUrl + '/assets/images/svg/009-next.svg',
			prevButtonSource: ui_data.themeUrl + '/assets/images/svg/010-back.svg',
			strings: ui_data.strings,
			bpm: '',
		}
	},
	watch: {
		volume() {
			let vm = this;
			this.wavesurfer.setVolume(vm.volume * .01);
		},
	},
	methods: {
		applyThemeWaveColor() {
			if ( ! this.wavesurfer ) {
				return;
			}

			const isLight = document.documentElement.getAttribute( 'data-theme' ) === 'light';
			this.wavesurfer.setWaveColor( isLight ? 'rgba(26,22,17,0.24)' : '#fff' );
		},
		toggleVolumeDrawer() {
			this.volumeDrawerVisible = ! this.volumeDrawerVisible;
		},
		hideVolumeDrawer() {
			this.volumeDrawerVisible = false;
		},
		prev () {
			let vm = this;
			this.playlistIndex = Math.max( 0, this.playlistIndex - 1 )
			this.wavesurfer.load( this.audioSources[this.playlistIndex]['audio'] );

			vm.wavesurfer.on( 'ready', () => {
				vm.wavesurfer.play();
				let id = vm.audioSources[vm.playlistIndex]['id'];
				vm.$store.commit( 'updateSongID', id );
				bus.$emit('updatePlayCount', id);
			});
		},
		next () {
			let vm = this;
			this.playlistIndex = Math.min( this.audioSources.length - 1, this.playlistIndex + 1 );
			this.wavesurfer.load( this.audioSources[this.playlistIndex]['audio'] );

			vm.wavesurfer.on( 'ready', function () {
				vm.wavesurfer.play();
				let id = vm.audioSources[vm.playlistIndex]['id'];
				vm.$store.commit( 'updateSongID', id );
				bus.$emit('updatePlayCount', id);
			});
		},
		repeat() {
			let vm = this;
			vm.isRepeating = ! vm.isRepeating;
		},
		myplayPause () {
			this.wavesurfer.playPause();
		},
		mute () {
			this.wavesurfer.toggleMute();
		},
		toggleFooterCart() {
			bus.$emit( 'toggleFooterCart' );
		},
		openModal() {
			let id = this.getSongID;
			bus.$emit( 'showModal' );
			this.$store.commit( 'updateAddToCartTrack', this.audioSources[this.playlistIndex] );
			setTimeout(() => {
				bus.$emit( 'updateBeatId', id );
				bus.$emit( 'updateModalPic', this.audioSources[this.playlistIndex].image );
			}, 30 );
		},
	},
	computed: {
		currentSources () {
			return [ this.audioSources[this.playlistIndex]['audio'] ];
		},
		...mapGetters([
			'getSongID',
		])
	},
	created () {
		let vm = this;
		let headerCart =document.querySelector('.header-cart');
		if ( headerCart ) {
			vm.cartTotal = headerCart.innerHTML;
		}
		vm.customProgressColor = ui_data.customProgressColor;
	},
	mounted () {
		let vm = this;
		const isLightTheme = document.documentElement.getAttribute( 'data-theme' ) === 'light';

		vm.wavesurfer = WaveSurfer.create({
			backend: 'MediaElement',
		  container: '#waveform',
		  waveColor: isLightTheme ? 'rgba(26,22,17,0.24)' : '#fff',
		  progressColor: this.customProgressColor,
		  height: 60,
		  barWidth: 1,
		  responsive: true,
		});

		vm._themeObserver = new MutationObserver( function () {
			vm.applyThemeWaveColor();
		});
		vm._themeObserver.observe( document.documentElement, {
			attributes: true,
			attributeFilter: [ 'data-theme' ],
		} );

		vm.wavesurfer.on( 'play', ( ) => {
			// Triggered as soon as a song is playing
			vm.isPlaying     = true;
			vm.hasPlayedOnce = true;
			bus.$emit( 'footerActive' );
			
			this.$store.commit( 'updatePlayingStatus', true );

    		// Set Title
			vm.trackName = vm.audioSources[vm.playlistIndex]['title'];

    		// Set Producer
			vm.producerName = vm.audioSources[vm.playlistIndex]['producer'];

			// Set Artwork
			vm.artworkImage = vm.audioSources[vm.playlistIndex]['image_tiny'];

			// Set The time remaining
			let duration = document.querySelector( '.song-duration' );

			//set link
			vm.trackLink = vm.audioSources[vm.playlistIndex]['slug'];
		});

		vm.wavesurfer.on( 'pause', ( ) => {
			vm.isPlaying = false;
			this.$store.commit( 'updatePlayingStatus', false );
		});

		bus.$on( 'setFirstSong', ( firstSong ) => {
			vm.wavesurfer.load( firstSong );
		});

		vm.wavesurfer.on( 'finish', ( text ) => {
			if ( vm.isRepeating === true ) {
				vm.wavesurfer.seekTo(0);
				vm.wavesurfer.play();
			} else {
				// When song ends, play the next one.
				vm.next();
			}
    	});

    	bus.$on( 'updateSong', ( index, id ) => {
			vm.playlistIndex = index;

			vm.wavesurfer.load( vm.audioSources[vm.playlistIndex].audio );
			vm.wavesurfer.on( 'ready', function () {
				vm.wavesurfer.play();
			});
			//update play count
			bus.$emit('updatePlayCount', id);
		});

		bus.$on( 'pauseSong', ( index, id ) => {
			this.wavesurfer.pause();
		});

		bus.$on( 'resumeSong', ( index, id ) => {
			this.wavesurfer.play();
		});

    	bus.$on( 'updatePlaylist', ( text ) => {
    		// set current audio sources based on the beatsOnDeck
    		vm.audioSources = vm.beatsOnDeck;
    	});

    	bus.$on( 'beatsOnDeck', ( incoming ) => {
			vm.beatsOnDeck = incoming;
    	});

    	bus.$on( 'updatePlayCount', ( id ) => {
			let vm = this;

			if ( ! ui_data.sendAnalyticsPlays ) {
				return false;
			}

			if ( typeof gtag === 'undefined' ) {
				return false;
			}

    		gtag( 'event', 'play', {
				'event_category': 'engagement',
				'event_label'   : vm.audioSources[vm.playlistIndex]['title'],
			});
    	});
	},
	beforeDestroy () {
		if ( this._themeObserver ) {
			this._themeObserver.disconnect();
		}
	},
}

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-player",class:{ active: _vm.hasPlayedOnce }},[_c('div',{staticClass:"controls"},[_c('button',{staticClass:"controls-prev-btn",attrs:{"title":"Previous Song"},on:{"click":_vm.prev}},[_c('img',{staticClass:"previous",attrs:{"src":_vm.prevButtonSource,"width":"16","height":"16","alt":"Previous"}})]),_vm._v(" "),_c('button',{staticClass:"playback",on:{"click":_vm.myplayPause}},[(_vm.isPlaying)?_c('div',{staticClass:"pause-button",attrs:{"width":"46","height":"46","title":"Pause","alt":"Pause"}},[_c('PauseImage')],1):_c('div',{staticClass:"play-button",attrs:{"width":"46","height":"46","alt":"Play","title":"Play"}},[_c('PlayImage')],1)]),_vm._v(" "),_c('button',{staticClass:"controls-next-btn",attrs:{"title":"Next Song"},on:{"click":_vm.next}},[_c('img',{staticClass:"next",attrs:{"src":_vm.nextButtonSource,"width":"16","height":"16","alt":"Next"}})]),_vm._v(" "),_c('button',{staticClass:"controls-repeat-btn",class:{ isrepeating: _vm.isRepeating },attrs:{"title":"Repeat"},on:{"click":_vm.repeat}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 489.688 489.688","width":"16","height":"16"}},[_c('path',{attrs:{"fill":"#929292","d":"M485.65 84.294l-111.9-75.3c-6.1-4.1-14.3.3-14.3 7.6v40.7H40.65c-19.1 0-34.6 15.5-34.6 34.6v183.9h69.2v-149.2h284.1v40.8c0 7.4 8.2 11.7 14.3 7.6l111.9-75.4c5.5-3.6 5.5-11.6.1-15.3zM414.45 362.994h-284.1v-40.7c0-7.4-8.2-11.7-14.3-7.6l-112 75.3c-5.4 3.6-5.4 11.6 0 15.3l111.9 75.4c6.1 4.1 14.3-.3 14.3-7.6v-40.8h318.7c19.1 0 34.6-15.5 34.6-34.6v-183.9h-69.2v149.2h.1z"}})])])]),_vm._v(" "),_c('div',{staticClass:"artwork"},[_c('img',{attrs:{"src":_vm.artworkImage,"id":"current-song-featured-image","width":"70","height":"70","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"track-info"},[_c('div',{staticClass:"song-producer-name"},[_c('p',{staticClass:"name"},[_c('router-link',{attrs:{"to":{ name: 'singledownload', params: { name: _vm.trackLink }}}},[_vm._v(_vm._s(_vm.trackName))])],1),_vm._v(" "),_c('p',{staticClass:"producer"},[_vm._v(_vm._s(_vm.producerName))])]),_vm._v(" "),_c('div',{staticClass:"duration-container",attrs:{"id":"waveform"}}),_vm._v(" "),_c('div',{staticClass:"bpm-container"},[_c('p',{staticClass:"song-duration"}),_vm._v(" "),_c('div',{staticClass:"bpm"},[_vm._v(_vm._s(_vm.bpm))])])]),_vm._v(" "),_c('div',{staticClass:"cart-status"},[_c('button',{attrs:{"id":"cart-status-add-cart-btn","aria-label":"View Pricing Options"},on:{"click":function($event){$event.stopPropagation();return _vm.openModal()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 510 510"}},[_c('path',{attrs:{"d":"M153 408c-28.05 0-51 22.95-51 51s22.95 51 51 51 51-22.95 51-51-22.95-51-51-51zM0 0v51h51l91.8 193.8-35.7 61.2c-2.55 7.65-5.1 17.85-5.1 25.5 0 28.05 22.95 51 51 51h306v-51H163.2c-2.55 0-5.1-2.55-5.1-5.1v-2.551l22.95-43.35h188.7c20.4 0 35.7-10.2 43.35-25.5L504.9 89.25c5.1-5.1 5.1-7.65 5.1-12.75 0-15.3-10.2-25.5-25.5-25.5H107.1L84.15 0H0zm408 408c-28.05 0-51 22.95-51 51s22.95 51 51 51 51-22.95 51-51-22.95-51-51-51z","fill":"#FFF"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.strings["Buy"]))])])]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.hideVolumeDrawer),expression:"hideVolumeDrawer"}],staticClass:"volume-controls"},[_c('button',{staticClass:"ui__mute",attrs:{"aria-label":"Mute Music"},on:{"click":_vm.toggleVolumeDrawer}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'volume-up'],"size":"sm"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.volumeDrawerVisible),expression:"volumeDrawerVisible"}],staticClass:"volume-range"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.volume),expression:"volume"}],attrs:{"type":"range","orient":"vertical","min":"0","max":"100","step":"1"},domProps:{"value":(_vm.volume)},on:{"__r":function($event){_vm.volume=$event.target.value}}})])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "FooterPlayer.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__